import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { styled } from "@mui/material/styles";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import Footer from "./footer/Footer";
// import { ToastContainer, toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'
import { useAppSelector } from "../app/hooks";

import { selectAuth } from "../features/auth/authSlice";
import Toast from "./Layout/Toast";
import Box from "@mui/material/Box";
import { apolloClient } from "../apollo/graphql";
import { HEARTBEAT } from "../apollo/mutations/users";

const HEARTBEAT_MS = 5 * 60 * 1000;

const pingPresence = () => {
  if (document.visibilityState !== "visible") return;
  apolloClient.mutate({ mutation: HEARTBEAT }).catch(() => undefined);
};
const DashboardLayoutRoot = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  height: "100vh",
  overflow: "hidden",
  width: "100%",
}));

const DashboardLayoutWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
  //paddingTop: 64,
  // [theme.breakpoints.up('lg')]: {
  //   paddingLeft: 256,
  // },
}));

const DashboardLayoutContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  flex: "1 1 auto",
  overflow: "auto",
  paddingTop: 64,
});

const DashboardLayoutContent = styled("div")(({ theme }) => ({
  flex: "1 1 auto",
  overflow: "auto",
  padding: theme.spacing(0.5),
  flexGrow: 1,
  p: 3,
}));

const DashboardLayout = () => {
  const { success, user } = useAppSelector(selectAuth);

  useEffect(() => {
    if (!user?._id) return;

    pingPresence();
    const timer = setInterval(pingPresence, HEARTBEAT_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") pingPresence();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [user?._id]);

  return (
    <DashboardLayoutRoot
      sx={{
        backgroundImage: "url('/bg4.jpg')",
        backgroundRepeat: "repeat",
        backgroundSize: "cover",
      }}
    >
      <DashboardNavbar />
      <DashboardSidebar />

      <Box>
        {success && <Toast severity="success">{success!.message}</Toast>}
      </Box>

      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
          <Box sx={{ flexGrow: 1 }} />

          <Footer />
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
